module.exports = __webpack_public_path__ + "static/media/sellers_banner.e4e0c097.jpg";